import React from 'react';
import { useTranslation } from 'react-i18next';
import CAppTitle from '../../../app/components/CAppTitle';
import FDocumentAccessTable from '../features/document-access/FDocumentAccessTable';
import langAdminDocumentAccess from '../langs/langAdminDocumentAccess';

const VAdminDocumentAccess = () => {
	const { t } = useTranslation();
	return (
		<>
			<CAppTitle title={t(langAdminDocumentAccess.title.tag)} />

			<FDocumentAccessTable />
		</>
	);
};

export default VAdminDocumentAccess;
